import { Controller } from "@hotwired/stimulus"

function buildPreviewText(location, special) {
  if (!location) {
    return "Stop by..."
  }

  let str = `Stop by ${location}`

  if (special) {
    str = str.concat(` for ${special}`)
  }

  if (str.indexOf("after the round") < 0) {
    str = str.concat(" after the round.")
  }

  return str
}

export default class extends Controller {
  static targets = ["location", "special", "preview", "submit"]

  connect() {
    this.locationCounter = document.getElementById("location-counter")
    this.specialCounter = document.getElementById("special-counter")
    this.updatePreview()
    this.updateInputCounters()
    this.updateSubmitLabel()
  }

  handleChange() {
    this.updatePreview()
    this.updateInputCounters()
    this.updateSubmitLabel()
  }

  updateSubmitLabel() {
    this.submitTarget.textContent = this.locationTarget.value.trim() ? "Save" : "Skip"
  }

  updatePreview() {
    this.previewTarget.innerHTML = buildPreviewText(this.locationTarget.value, this.specialTarget.value)
  }

  updateInputCounters() {
    let locationChars = this.locationTarget.value.length
    let specialChars = this.specialTarget.value.length
    let locationMax = this.locationCounter.innerHTML.split("/")[1]
    let specialMax = this.specialCounter.innerHTML.split("/")[1]

    this.locationCounter.innerHTML = `${locationChars}/${locationMax}`
    this.specialCounter.innerHTML = `${specialChars}/${specialMax}`
  }
}
